const initialDailyPositionState = {
  loading: false,
  data: null,
  error: null,
};

export const cashFlowDailyPositionReducer = (state = initialDailyPositionState, action) => {
  switch (action.type) {
    case "GET_CASHFLOW_DAILY_POSITION_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_CASHFLOW_DAILY_POSITION_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_CASHFLOW_DAILY_POSITION_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialAgingState = {
  loading: false,
  data: null,
  error: null,
};

export const cashFlowAgingReducer = (state = initialAgingState, action) => {
  switch (action.type) {
    case "GET_CASHFLOW_AGING_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_CASHFLOW_AGING_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_CASHFLOW_AGING_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
